<template>
  <div>
    <v-navigation-drawer id="core-navigation-drawer" v-model="drawer" :dark="menu_mode === 'dark'"
      :expand-on-hover="expandOnHover" :src="menuImage" mobile-breakpoint="960" app mini-variant-width="64" width="260"
      height="" v-bind="$attrs">
      <template v-slot:img="props">
        <v-img :gradient="`to bottom, ${barColor}`" v-bind="props" />
      </template>

      <div class="logo-container" style="min-height: 64px">
        <div class="logo-container" style="width: 64px; height: 64px; float: left; position: absolute">
          <a class="mute-link" href="/">
            <img class="logo-mini" :src="logo" style="width: 70%; height: 70%; top: 15%; position: absolute" />
          </a>
        </div>
        <div class="titolo" style="
              display: table;
              float: right;
              height: 64px;
              width: 180px;
              position: absolute;
              left: 74px;
            ">
          <span class="logo-normal" style="display: table-cell; vertical-align: middle"><a class="mute-link" href="/"
              style="white-space: normal; font-size: 20px">{{ title }}</a>
          </span>
        </div>
      </div>

      <v-divider class="mb-1" />

      <v-list dense nav>
        <base-item-group class="profile-menu" :ifHoover="false" :item="profile" />
      </v-list>

      <v-divider class="mb-2" />

      <div id="core-menu-container">
        <div id="core-menu-drawer">
          <template v-for="(item, i) in computedItems">
            <base-item-group v-if="item.children" :ifHoover="true" :key="`group-${i}`" :item="item">
              <!--  -->
            </base-item-group>

            <base-item v-else :key="`item-${i}`" :item="item" />
          </template>
        </div>
      </div>
      <!-- Style cascading bug  -->
      <!-- https://github.com/vuetifyjs/vuetify/pull/8574 -->
    </v-navigation-drawer>
  </div>
</template>

<script>
// Utilities

export default {
  name: "DashboardCoreDrawer",

  props: {
    expandOnHover: {
      type: Boolean,
      default: false,
    },
  },

  data: () => ({
    modules: [],
    title: "",
    logo: "",
    drawer: null,
    menu_mode: "dark",
    barColor: "rgba(255, 255, 255, 1), rgba(255, 255, 255, .8)",
    menuImage: "/API/public/portal/getImage/THEME/sidebar",
    image: window.myData.avatar,
    name: window.myData.title,
    items: [],
    scrollbarSettings: {
      wheelPropagation: false,
      suppressScrollX: true,
    },
  }),

  computed: {
    verifyChangeAvatar() {
      return this.$changeAvatar.changeAvatarRsp.updated;
    },

    computedItems() {
      return this.items.map(this.mapItem);
    },
    profile() {
      return {
        avatar: true,
        group: "",
        image: this.image,
        title: this.name,
        children: [
          {
            icon: "mdi-face-man-profile",
            to: "/portal/profile",
            title: this.$t("profile"),
          },
          {
            icon: "mdi-lock-outline",
            to: "/auth/lock",
            title: this.$t("lock"),
          },
          {
            icon: "mdi-location-exit",
            to: "/auth/login",
            title: this.$t("logoff"),
          },
        ],
      };
    },
  },

  watch: {
    "$vuetify.breakpoint.smAndDown"(val) {
      this.$emit("update:expandOnHover", !val);
    },
    verifyChangeAvatar: function (changed) {
      this.name = window.myData.user;
      this.image =
        window.myData.avatar +
        "?t=" +
        Math.random().toString(36).substring(2, 15) +
        Math.random().toString(36).substring(2, 15);
    },
  },

  methods: {
    openMenu() {
      this.drawer = true;
    },
    showHelp() {
      this.$router.push({ path: "/portal/guida" });
    },
    mapItem(item) {
      return {
        ...item,
        children: item.children ? item.children.map(this.mapItem) : undefined,
        title: item.title,
      };
    },
    hexToRgb(hex) {
      var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
      return result
        ? "rgba(" +
        parseInt(result[1], 16) +
        ", " +
        parseInt(result[2], 16) +
        ", " +
        parseInt(result[3], 16) +
        ", .8), rgba(" +
        parseInt(result[1], 16) +
        ", " +
        parseInt(result[2], 16) +
        ", " +
        parseInt(result[3], 16) +
        ", .8)"
        : null;
    },
  },
  created() {
    let _ = this;
    _.title = window.systemData.SYSTEM.title;
    _.logo = window.systemData.SYSTEM.favicon;
    _.image = window.myData.avatar;
    _.name = window.myData.user;
    _.barColor = _.hexToRgb(window.systemData.THEME.menu_color);
    _.menu_mode = window.systemData.THEME.menu_mode;
    _.modules = window.systemData.modules;
  },
  mounted() {
    let _ = this;
    _.items = [];
    this.chiamataAxios("GET", "/auth/portal/getMenu").then((response) => {
      let data = response.data;
      // Aggiunge dashboard
      let home = {
        title: "dashboard",
        icon: "mdi-view-dashboard",
        to: "/portal/dashboard",
      };
      _.items.push(home);
      for (let l1 = 0; l1 < data.length; l1++) {
        let elem1 = {
          title: window.selectedLanguage && data[l1].translate[window.selectedLanguage] && data[l1].translate[window.selectedLanguage].descr ? data[l1].translate[window.selectedLanguage].descr : data[l1].descr,
          icon: data[l1].icon,
          to: data[l1].url,
        };
        if (data[l1].type !== "A") elem1.children = [];
        for (let l2 = 0; l2 < data[l1].child.length; l2++) {
          let elem2 = {
            title: window.selectedLanguage && data[l1].child[l2].translate[window.selectedLanguage] && data[l1].child[l2].translate[window.selectedLanguage].descr ? data[l1].child[l2].translate[window.selectedLanguage].descr : data[l1].child[l2].descr,
            icon: data[l1].child[l2].icon,
            to: data[l1].child[l2].url,
          };
          elem1.children.push(elem2);
        }
        if (data[l1].type === "A" || elem1.children.length > 0)
          _.items.push(elem1);
      }
      _.items.push({
        title: _.$t("help_guide"),
        icon: "mdi-help-circle",
        to: "/portal/guida",
      });
    });
  },
};
</script>

<style lang="sass">
@import '~vuetify/src/styles/tools/_rtl.sass'
img[src='']
  display: none
.swal2-container
  z-index: 10000 !important
#core-navigation-drawer
  height: calc(100vh - 29px)
  z-index: 20
  &.v-navigation-drawer--is-mobile
    height: 100vh
  .v-navigation-drawer__content
    overflow-y: hidden
    height: 100%
    display: flex
    flex-direction: column
    .logo-container
      max-height: 64px
      .logo-mini
        border: none
  .profile-menu
    .v-list-item
      justify-content: normal
      padding: 0 4px
  #core-menu-container
    overflow-y: overlay
    overflow-x: hidden
    height: 100%
    width: 100%
    padding-right: 10px
    padding-left: 10px
    #core-menu-drawer
      .v-list
        padding: 0px
      .v-list--nav
        margin-bottom: 30px
      &.v-list-item
        padding: 0 4px
      .v-list-item
        margin: 5px 0px
        padding: 0 10px
        border-radius: 4px

.bottoneHelp
  height: auto !important
  width: auto !important
  left: 25px
.guida
  bottom: 0px
  width: 100%
  position: absolute
  background-color: white
  height: 29px
.mute-link
  text-decoration: none
  color: inherit
#core-navigation-drawer
  &.v-navigation-drawer--mini-variant
    .v-list-item
      .v-list-group--sub-group
        display: block !important

    .v-list-group__header.v-list-item--active:before
      opacity: .24

    .v-list-item
      &__icon--text,
      &__icon:first-child
        justify-content: center
        text-align: center
        width: 20px

        +ltr()
        margin-right: 24px
        margin-left: 12px !important

        +rtl()
        margin-left: 24px
        margin-right: 12px !important

    .v-list--dense
      .v-list-item
        &__icon--text,
        &__icon:first-child
          margin-top: 10px

    .v-list-group--sub-group
      .v-list-item
        +ltr()
        padding-left: 8px

        +rtl()
        padding-right: 8px

      .v-list-group__header
        +ltr()
        padding-right: 0

        +rtl()
        padding-right: 0

        .v-list-item__icon--text
          margin-top: 19px
          order: 0

        .v-list-group__header__prepend-icon
          order: 2

          +ltr()
          margin-right: 8px

          +rtl()
          margin-left: 8px
</style>
